"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalLink = exports.LegalLinks = exports.CopyrightText = exports.Row = exports.Bar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Bar = _styledComponents.default.div.withConfig({
  displayName: "SubFooterstyle__Bar",
  componentId: "fhk3z4-0"
})(["align-items:center;display:flex;background:", ";color:", ";font-size:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.subFooter.backgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.subFooter.textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.subFooter.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.subFooter.padding;
});
exports.Bar = Bar;
var Row = _styledComponents.default.div.withConfig({
  displayName: "SubFooterstyle__Row",
  componentId: "fhk3z4-1"
})(["display:flex;flex-direction:column-reverse;justify-content:space-between;line-height:", ";width:100%;@media (min-width:", "){flex-direction:row;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.lg;
});
exports.Row = Row;
var CopyrightText = _styledComponents.default.div.withConfig({
  displayName: "SubFooterstyle__CopyrightText",
  componentId: "fhk3z4-2"
})(["text-align:center;@media (min-width:", "){max-width:", ";", " margin-top:0;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.lg;
}, function (_ref8) {
  var hasLinks = _ref8.hasLinks;
  return hasLinks ? '50%' : '100%';
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      text-align: left;\n    "]))));
exports.CopyrightText = CopyrightText;
var LegalLinks = _styledComponents.default.ul.withConfig({
  displayName: "SubFooterstyle__LegalLinks",
  componentId: "fhk3z4-3"
})(["display:flex;flex-direction:column;margin-bottom:", ";font-weight:", ";@media (min-width:", "){align-items:center;flex-direction:row;margin-bottom:0;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.sm;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.semiBold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.lg;
});
exports.LegalLinks = LegalLinks;
var LegalLink = _styledComponents.default.li.withConfig({
  displayName: "SubFooterstyle__LegalLink",
  componentId: "fhk3z4-4"
})(["display:flex;justify-content:center;margin-bottom:", ";@media (min-width:", "){display:inline-block;justify-content:flex-start;margin-bottom:0;", "}a{color:", ";font-weight:", ";text-decoration:none;&:hover{color:", ";}}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.xs;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.lg;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-left: ", ";\n    "])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.md;
}), function (_ref15) {
  var theme = _ref15.theme;
  return theme.subFooter.textColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontWeight.semiBold;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.link.colorHover;
});
exports.LegalLink = LegalLink;